<template>
    <div class="row">
        <div class="col">
            <card class="error" v-if="clientOfferRejected">
                <card-content>
                    <span class="subtitle-1"><translate>Sie haben dieses Angebot leider abgelehnt. Es kann daher nicht mehr bestellt werden!</translate></span>
                </card-content>
            </card>

            <card class="error" v-if="clientOfferInvalid">
                <card-content>
                    <span class="subtitle-1"><translate>Das Angebot ist abgelaufen. Es kann daher nicht mehr bestellt werden!</translate></span>
                </card-content>
            </card>
            <card class="card--border-top-secondary">
                <card-header>
                    <card-overline>
                        <translate>Unsere Empfehlung</translate>
                    </card-overline>
                    <card-title>
                        <span><translate>Angebot</translate> {{ askForQuote.pfnumber }}</span>
                        <div class="badges">
                            <badge v-if="!clientOfferAccepted">
                                <translate>gültig bis:</translate>
                                {{ clientOffers[0].offer_valid_date_string }}
                            </badge>
                            <badge v-if="clientOfferAccepted">
                                <translate>bestellt</translate>
                            </badge>
                            <badge color="error" @click="rejectDialog = !rejectDialog" v-if="!hasClientOrder && !clientOfferRejected && !clientOfferInvalid" style="cursor: pointer">
                                <translate>Angebot ablehnen</translate>
                            </badge>
                        </div>
                    </card-title>
                </card-header>
                <card-content>
                    <table class="table table--stripped">
                        <thead>
                        <tr>
                            <th>
                                <translate>P.-Nr.</translate>
                            </th>
                            <th>
                                <translate>Stück</translate>
                            </th>
                            <th>
                                <translate>Lieferzeit <span>ab Bestellung</span></translate>
                            </th>
                            <th>
                                <translate>Lieferdatum<span>bei heutiger Bestellung</span></translate>
                            </th>
                            <th>
                                <translate>Stückpreis</translate>
                            </th>
                            <th>
                                <translate>Nettopreis</translate>
                            </th>
                            <th>
                                <translate>Steuer<span>19% Ust.</span></translate>
                            </th>
                            <th>
                                <translate>Gesamtpreis<span>inkl. Versand</span></translate>
                            </th>
                            <th v-if="!hasClientOrder && !clientOfferRejected && !clientOfferInvalid" class="small"></th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(clientOffer, index) in clientOffers" :key="clientOffer.index" :class="{'selected' : clientOffer.accepted_at }">
                            <td><span v-if="index === 0">{{ clientOffer.prod_no }}</span></td>
                            <td>{{ clientOffer.amount }}</td>
                            <td>{{ clientOffer.delivery_days_client }}
                                <translate>Tage</translate>
                            </td>
                            <td>{{ clientOffer.delivery_date }}</td>
                            <td>{{ this.$currency(clientOffer.piece_price) }}</td>
                            <td>{{ this.$currency(clientOffer.net_price) }}</td>
                            <td>{{ this.$currency(clientOffer.ust) }}</td>
                            <td>{{ this.$currency(clientOffer.offer_price) }}</td>
                            <td v-if="!hasClientOrder && !clientOfferRejected && !clientOfferInvalid" class="small">
                                <form-link :href="clientOffer.add_offer" icon="shopping-cart"
                                           dense="true" color="secondary" :disabled="isInCart(clientOffer.id)"/>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    <component-offer-reject-modal :ask-for-quote="askForQuote" v-if="rejectDialog"
                                            @closeDialog="rejectDialog = false" />
                </card-content>
            </card>
        </div>
    </div>
</template>

<script>
import Card from '@partfactory/Shared/Card/Card';
import CardHeader from '@partfactory/Shared/Card/CardHeader';
import CardOverline from '@partfactory/Shared/Card/CardOverline';
import CardContent from '@partfactory/Shared/Card/CardContent';
import CardTitle from '@partfactory/Shared/Card/CardTitle';
import FormLink from '@partfactory/Shared/Form/FormLink';
import Badge from '@partfactory/Shared/Elements/Badge';
import ComponentOfferRejectModal from '@partfactory/Pages/Client/Component/ComponentOfferRejectModal';

export default {
    name: 'ComponentOffers',
    components: {
        ComponentOfferRejectModal,
        Badge, FormLink, CardTitle, CardContent, CardOverline, CardHeader, Card},
    props: {
        askForQuote: Object,
        hasClientOrder: Boolean,
        clientOfferRejected: Boolean,
        clientOfferInvalid: Boolean,
    },
    data() {
        let rejectDialog = false;
        return { rejectDialog };
    },
    computed: {
        clientOfferAccepted () {
            return !! this.askForQuote.client_offers.filter((clientOffer) => {
                return clientOffer.accepted_at;
            }).length;
        },
        clientOffers() {
            return this.askForQuote.client_offers.map(clientOffer => {
                clientOffer.prod_no = clientOffer.producer_user.prod_no;

                clientOffer.piece_price = clientOffer.net_price / clientOffer.amount;
                clientOffer.piece_price = (Math.round(clientOffer.piece_price * 100) / 100).toFixed(2);
                clientOffer.ust = clientOffer.offer_price - clientOffer.net_price;
                clientOffer.ust = (Math.round(clientOffer.ust * 100) / 100).toFixed(2);

                let delivery_date = '';
                if (this.$moment().isBusinessDay() && !this.$moment().isHoliday()) {
                    delivery_date = this.$moment().add(clientOffer.delivery_days_client, 'days');
                } else {
                    delivery_date = this.$moment().nextBusinessDay().add(clientOffer.delivery_days_client, 'days');
                }
                if (!delivery_date.isBusinessDay() || delivery_date.isHoliday()) {
                    delivery_date = delivery_date.nextBusinessDay();
                }

                // delivery_date = delivery_date.add((clientOffer.delivery_days_client - clientOffer.delivery_days_producer), 'days');

                if (!delivery_date.isBusinessDay() || delivery_date.isHoliday()) {
                    delivery_date = delivery_date.nextBusinessDay();
                }

                // clientOffer.delivery_days_client = delivery_date.diff(this.$moment(), 'days');

                clientOffer.delivery_date = delivery_date.format('DD.MM.YYYY');

                clientOffer.offer_valid_date_string = this.$date(clientOffer.offer_valid_date);

                clientOffer.add_offer = this.$$route('checkout.add-offer', {'clientOffer': clientOffer.id});

                return clientOffer;
            });
        },
    },
    methods: {
        isInCart(offerId) {
            const isInCart = this.$page.props?.cart?.filter((offer) => {
                return offer.id === offerId;
            });
            return isInCart?.length === 0 || isInCart === undefined ? null : 'disabled';
        },
    },
};
</script>
